<template>
    <views class="tab">
        <views
            v-for="item in tabs"
            :key="item.id"
            :class="{'active': activeName === item.name}"
            class="tab-list"
            @click="change(item)">
            {{ item.name }}
        </views>
    </views>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        activeName: {
            type: String,
            default: ''
        }
    },
    methods: {
        change(item) {
            this.$emit('change', item)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
